import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getModels,
  getModelsByMake,
  createModel,
  updateModel,
  deleteModel,
} from '../../lib/vehicleModels';

export const fetchModels = createAsyncThunk(
  'models/fetchModels',
  async () => {

    const data = await getModels();

    return data;
  }
);

export const fetchModelsByMake = createAsyncThunk(
  'models/fetchModelsByMake',
  async ({ vehicleMakeId }) => {
    const data = await getModelsByMake(vehicleMakeId);

    return data;
  }
);

export const addModel = createAsyncThunk(
  'models/addModel',
  async (body, { rejectWithValue }) => {
    try {
      const data = await createModel(body);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const editModel = createAsyncThunk(
  'models/editModel',
  async ({ modelId, body }) => {
    const data = await updateModel(modelId, body);
    return data;
  }
);

export const removeModel = createAsyncThunk(
  'models/removeModel',
  async (modelId) => {
    await deleteModel(modelId);
    return modelId;
  }
);
